import { CalendarCheck } from "lucide-react";
import { SITE, WA_MESSAGES } from "../data/site";
import { waLink } from "../lib/whatsapp";
import { SectionHeading } from "./SectionHeading";
import { Reveal } from "./Reveal";

export const StrategyCall = () => {
    const hasCalendar = Boolean(SITE.calendarUrl);
    const href = hasCalendar ? SITE.calendarUrl : waLink(WA_MESSAGES.call);

    return (
        <section id="strategy-call" className="py-16 sm:py-24" data-testid="strategy-call-section">
            <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
                <div className="grid items-center gap-10 rounded-3xl border border-brand-brown/10 bg-brand-cream p-8 sm:p-12 lg:grid-cols-[1.2fr_0.8fr] lg:p-16">
                    <div>
                        <SectionHeading
                            chapter="09"
                            kicker="Strategy Call"
                            title="Prefer to talk it through? Book a strategy call."
                            lead="A focused conversation about your business: where customers are leaking, what to fix first, and whether the 033 system is the right fit. No scripts, no pressure."
                            testid="strategy-call-heading"
                        />
                    </div>
                    <Reveal delay={0.15}>
                        <div className="flex flex-col items-start gap-4 lg:items-end">
                            <a
                                href={href}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="strategy-call-button"
                                className="inline-flex items-center justify-center gap-2 rounded-full bg-brand-orange px-8 py-4 text-sm font-semibold text-white transition-colors duration-200 hover:bg-brand-orange-dark sm:text-base"
                            >
                                <CalendarCheck size={18} aria-hidden="true" />
                                Book a Strategy Call
                            </a>
                            {!hasCalendar && (
                                <p className="text-xs text-brand-muted lg:text-right">
                                    Opens WhatsApp — we'll confirm a time that suits you.
                                </p>
                            )}
                        </div>
                    </Reveal>
                </div>
            </div>
        </section>
    );
};
